import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { GlobalContext } from "../context";
import { link } from "fs";
import { useMediaQuery } from 'react-responsive';
import * as awsui from "@cloudscape-design/design-tokens";
import "../index.css";
import { CustomButton } from "../components/buttons";

function About() {
  const navigate = useNavigate();
  const { 
    activeHref, setActiveHref,
  } = useContext(GlobalContext);

  const screenWidth_600 = useMediaQuery({query: "only screen and (max-width : 600px)"})
  const screenWidth_800 = useMediaQuery({query: "only screen and (max-width : 800px)"})
  const screenWidth_1000 = useMediaQuery({query: "only screen and (max-width : 1000px)"})

  return (
    <>
      <center>
        <div className="body-content">
          <ContentLayout
            header={
              <div 
                className="series-header-container" 
                style={{
                  height: "15vw",
                  maxHeight: "200px",
                  minHeight: "80px",
                }}
              >
                <img 
                  className="series-header-img"
                  src="/images/frg-name-horiz-light.png"
                />
              </div>
            }
          >
            <Container
              header={<Header variant="h1">  </Header>}
            >
            </Container>
          </ContentLayout>
        </div>
        {/* <div style={{background: "none", width: "100%", paddingTop: "50px", paddingBottom: screenWidth_600? "20px" : "50px"}}>
          <div className="body-content">
            <div style={{maxWidth: "90%",textAlign: "left" }}>
              <h2>Who are FRG - Formula Racing Group?</h2>
              <br />
              <p>Widely recognised as one of the premier Esport Leagues on the iracing service, FRG ESPORTS is the undisputed leader for top level competition for sim-racers throughout Australia & New Zealand. Utilising the iRacing platform for our long-running F3A Formula 3 Series, and now with our suite of officially sanctioned eseries for Formula Ford, FIA Formula 4 and the spectacular S5000’s, FRG have set the standard for online motorsport in Australia. </p>
              <br />
              <p>Our in-house development of external Live Timing for qualification events, and with numerous other technical additions in the works FRG are looking to deliver a new level of professionalism for the simracer. That, in conjunction with our Live Race Control, Manual Safety Car, Live Race Review Broadcasts and in association with the highly acclaimed RSTV Broadcast team, FRG now have over 1000 competitors currently registered with the Group, events that regularly attract well in excess of 100 entries, and often see viewer number exceeding 1000 for an event. </p>
              <br />
              <p>As a result FRG have begun a strong association with Motorsport Australia and are moving toward the international arena. Our latest ASIA-PACIFIC JUNIOR ESPORTS CHALLENGE for the entire Oceanic region, and TRI NATIONS CUP events in association with Motorsport Australia, Motorsport New Zealand and Motorsport UK are witness to our growth.</p>
              <br />
              <p><b>We can't wait to see what 2024 has in store!</b></p>

            </div>
          </div>
        </div> */}
        <div style={{background: awsui.colorBackgroundInputDefault, width: "100%", paddingTop: "50px", paddingBottom: screenWidth_600? "20px" : "50px"}}>
          <div className="body-content">
            <div data-privacy-policy style={{maxWidth: "90%",textAlign: "left" }}>
              <h4>FRG E-SPORTS Data and Privacy Policy:</h4>
              At FRG E-SPORTS, we are committed to protecting your privacy and ensuring the
              security of your personal information. This Privacy Policy outlines how we handle,
              use, and safeguard the data you provide to us in accordance with Australian
              standards and laws.<p />
              <br />
              <h5>1. Information Collection:</h5>
              We collect personal information, including your name, address, email address,
              and age, during the registration process for the purposes of facilitating your
              participation in our racing organization. We only collect information that is
              necessary and relevant to your engagement with our services.<p />
              <br />
              <h5>2. Use of Information:</h5>
              The personal information we collect is primarily used to:<p />
              <ul data-privacy-policy>
                <li>Facilitate your registration and participation in our racing events.</li>
                <li>Communicate important updates, race schedules, and event information.</li>
                <li>Ensure compliance with age restrictions and applicable laws.</li>
                <li>Conduct statistical analysis to enhance and improve our services.</li>
                <li>Seek feedback and conduct surveys to improve your experience.</li>
                <li>Share aggregated and anonymized data for research, marketing, or sponsorship purposes.</li>
              </ul>
              <br />
              <h5>3. Data Security:</h5>
              We employ industry-standard security measures to protect your personal
              information from unauthorized access, loss, or misuse. We regularly review
              and update our systems to ensure the confidentiality and integrity of your data.<p />
              <br />
              <h5>4. Third-Party Disclosure:</h5>
              FRG E-SPORTS does not disclose your personal information to any third
              parties without your explicit consent, except in the following circumstances:<p />
              <ul data-privacy-policy  style={{color: awsui.colorTextBodyDefault}}>
                <li>Sharing data with authorized sponsors: With your consent, we may
                share your information with our sponsors for promotional and
                sponsorship-related activities. However, we will never disclose your
                information without obtaining your explicit permission.</li>
                <li>Legal requirements: We may be obligated to disclose your personal
                information in response to a court order, legal process, or governmental request.</li>
              </ul>
              <br />
              <h5>5. Retention of Information:</h5>
              We retain your personal data for as long as necessary to fulfil the purposes
              outlined in this policy or as required by law. If you would like to have your
              information removed from our records, please contact us using the details
              provided below.<p />
              <br />
              <h5>6. Access and Control:</h5>
              You have the right to access, update, correct, or delete the personal
              information we hold about you. If you wish to exercise these rights or have
              any concerns about your data, please contact us using the details provided
              below.<p />
              <br />
              <h5>7. Compliance with Australian Law:</h5>
              We adhere to the data protection and privacy laws of Australia, including the
              Privacy Act 1988. This policy aligns with the Australian Privacy Principles
              (APPs) and ensures our practices are compliant with applicable regulations.<p />
              <br />
              <h5>8. Contact Information:</h5>
              If you have any questions, concerns, or requests regarding your personal data
              or this Privacy Policy, please contact us using the details provided below.
            </div>
          </div>
        </div>
        <div style={{background: awsui.colorBackgroundStatusInfo, width: "100%", paddingTop: "50px", paddingBottom: screenWidth_600? "20px" : "50px"}}>
          <div className="body-content">
          <Box textAlign="center">
              <Link 
                href="mailto:formularacinggroup@gmail.com"
                target="_blank"
                // onFollow={ (event) => {
                //   event.preventDefault();
                //   navigate(event.detail.href!)
                // }}
              >
                <CustomButton
                  type="button"
                  onMouseEnter={ (event:any) => {
                    event.currentTarget.style.filter = `hue-rotate(110deg)`;
                  }}
                  onMouseLeave={ (event:any) => {
                    event.currentTarget.style.filter = "none";
                  }}
                  style={{
                    height: "80px", 
                    width: "50%", 
                    minWidth: "200px",
                    background: awsui.colorBackgroundNotificationGreen, 
                    borderRadius: "2px", 
                    alignItems: "center", 
                    color: "white", 
                    fontWeight: "normal", 
                    fontSize: screenWidth_800 ? "24px" : "32px", 
                    borderWidth: "0",
                    lineHeight: "35px",
                  }}
                >
                  CONTACT FRG
                </CustomButton>
              </Link>
            </Box>
          </div>
        </div>
      </center>
    </>    
  );
}

export default About;
